import { BaseModel } from '../../_base/crud';

export class Insurance extends BaseModel {
  id: number;
  name;
  bin;
  pcn;
  insuranceType;
  insurance_type;
  submissionType;
  submission_type;
  phone;

  clear(): void {
    this.id = 0;
    this.name = null;
    this.bin = null;
    this.pcn = null;
    this.phone = null;
    this.insuranceType = null;
    this.insurance_type = null;
    this.submissionType = null;
    this.submission_type = null;
  }
}
